export default __webpack_public_path__ + "static/media/folder.d6140922.png";